/**
 * Who a product is "by". A plugin is sold under its developer name — that is
 * what the box says and what the buyer looks for on the invoice — while a
 * sample pack carries the creator who uploaded it. The creator stays the
 * seller of record either way; this is display only.
 */
export function productByline(product: any): string {
    if (!product) return ''
    if (product.category === 'Audio Software' && product.audioSoftware?.developer) {
        return String(product.audioSoftware.developer)
    }
    return product.creator?.name || ''
}
